{
  "/images/guides/hotel-lake/dock-and-shoreline-1600.webp": {
    "width": 1600,
    "height": 1200,
    "smallSrc": "/images/guides/hotel-lake/dock-and-shoreline-800.webp"
  },
  "/images/guides/pender-hill/summit-panorama-1600.webp": {
    "width": 1600,
    "height": 702,
    "smallSrc": "/images/guides/pender-hill/summit-panorama-800.webp"
  },
  "/images/guides/pender-hill/hotel-lake-island-1600.webp": {
    "width": 1600,
    "height": 2133,
    "smallSrc": "/images/guides/pender-hill/hotel-lake-island-800.webp"
  },
  "/images/guides/pender-hill/forest-trail-1600.webp": {
    "width": 1600,
    "height": 2133,
    "smallSrc": "/images/guides/pender-hill/forest-trail-800.webp"
  },
  "/images/guides/pender-hill/lake-through-the-trees-1600.webp": {
    "width": 1600,
    "height": 2133,
    "smallSrc": "/images/guides/pender-hill/lake-through-the-trees-800.webp"
  },
  "/images/guides/pender-hill/lake-and-harbour-view-1600.webp": {
    "width": 1600,
    "height": 1200,
    "smallSrc": "/images/guides/pender-hill/lake-and-harbour-view-800.webp"
  },
  "/images/guides/pender-hill/coastal-view-1600.webp": {
    "width": 1600,
    "height": 1200,
    "smallSrc": "/images/guides/pender-hill/coastal-view-800.webp"
  },
  "/images/guides/pender-hill/park-entrance-1600.webp": {
    "width": 1600,
    "height": 2133,
    "smallSrc": "/images/guides/pender-hill/park-entrance-800.webp"
  }
}
